
export enum DerbyshireRecordType  {           
    Monument = "mon",     
    Source = "source",
    Designation = "desig",
    Paleochannels = "paleo"
}  

export enum DerbyshireRecordSubType  {   
    ConservationArea = "COA",
    ListedBuilding = "LB",
    RegisteredParkAndGarden = "RG",
    ScheduledMonument = "SAM",
    WorldHeritageSite = "WHS",
    WorldHeritageSiteBufferZone = "BZ",
    AreaOfArchaeologicalInterest = "AAI"
}  
